module.exports = __webpack_public_path__ + "sca-veracode-logo-footer.png";